module.exports = {"disabled":"<strong>Let op:</strong> Deze betaalwijze kan gebruikt worden tot een maximum van :%maximumAmount% per transactie"};